export default __webpack_public_path__ + "static/media/logo.d01d4753.svg";